import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { RuleService, } from '../../infrastructure/services/reglas.service';
import { LoaderService } from '../../infrastructure/services/loader.service';
import { HistorialService, Historial } from '../../infrastructure/services/historial.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/share';
import { Subscription } from 'rxjs/Subscription';

@Component({
  templateUrl: './reglas.historial.component.html',
})
export class ReglasHistorialComponent implements OnInit, OnDestroy {
  historial: Historial[];
  selected: Historial;
  codRegla: string;
  textoIzquierda = '';
  textoDerecha = '';
  subscription: Subscription;

  constructor(private aRoute: ActivatedRoute,
              public loader: LoaderService,
              private historialService: HistorialService,
              private reglasService: RuleService,
              private router: Router) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.codRegla = params['codRegla'];
      this.subscription = this.historialService.getHistorial('Regla', this.codRegla)
        .subscribe(historial => this.historial = historial);
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  seleccionar(index) {
    this.textoIzquierda = '';

    if (index < this.historial.length - 1) {
      this.textoIzquierda = this.historial[index + 1].data.TextoRegla;
    }

    this.textoDerecha = this.historial[index].data.TextoRegla;
    this.selected = this.historial[index];
  }

  volverAVersion() {
    this.reglasService
      .cambiarAVersion(this.codRegla, this.selected.id)
      .then(res => this.router.navigate(['../', ], { relativeTo: this.aRoute }));
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/reglas/reglas.historial.component.ts